import { useAppDispatch, useAppSelector } from "redux-share/hooks";
import ChevronRightIcon from "../../icon-components/chevronRight";
import { shallowEqual } from "react-redux";
import { ISubtitleColor, SettingSections, SubtitleColors, SubtitleColorsCode } from "interfaces";
import { setActiveElements } from "redux-share/slices/controllerSlice";
import { setSettingPopover } from "redux-share/slices/popoversSlice";
import { memo } from "react";
import { createSettings } from "redux-share";
import { setUserSettings } from "redux-share/slices/userSlice";

const colors = [
    { textName: SubtitleColors.black, textColor: SubtitleColorsCode.black },
    { textName: SubtitleColors.white, textColor: SubtitleColorsCode.white },
    { textName: SubtitleColors.yellow, textColor: SubtitleColorsCode.yellow },
    { textName: SubtitleColors.blue, textColor: SubtitleColorsCode.blue },
    { textName: SubtitleColors.green, textColor: SubtitleColorsCode.green }
];

const SubtitlesTextColorsMenu = ({ setSection }: any) => {
    const dispatch = useAppDispatch();
    const { settings } = useAppSelector(({ user: { settings } }) => ({ settings }), shallowEqual);

    return (
        <div id={SettingSections.subtitlesTextColors} className="animate__animated animate__fadeIn pl-p-[14px]">
            <div
                className={`pl-flex pl-items-center pl-cursor-pointer pl-gap-2 pl-pb-3 pl-mb-3 pl-border-b pl-border-b-gray-300 dark:pl-border-b-dark-4`}
                onClick={() => setSection(SettingSections.subtitlesSettingMenu)}
            >
                <div className={`pl-rounded-[4px] pl-p-1 pl-bg-gray-300 dark:pl-bg-dark-4`}>
                    <ChevronRightIcon className={`pl-w-3 pl-h-3 pl-stroke-gray-800`} />
                </div>
                <p className="pl-text-[15px] pl-font-medium">رنگ متن زیرنویس</p>
            </div>
            <ul className="pl-flex pl-flex-col pl-p-0 pl-m-0">
                {colors.map((color: ISubtitleColor, index: number) => (
                    <li
                        key={index}
                        className={`pl-flex pl-items-center pl-text-[14px] pl-rounded-[4px] pl-relative pl-cursor-pointer pl-leading-6 hover:pl-bg-main/[0.1] hover:dark:pl-bg-white/[0.25] pl-p-1 pl-pr-2 ${
                            settings.subtitle_text_color === color.textColor && "pl-bg-main-light hover:!pl-bg-main-light pl-text-dark-5"
                        }`}
                        onClick={() => {
                            dispatch(setUserSettings({ ...settings, subtitle_text_color: color.textColor! }));
                            createSettings({ ...settings, subtitle_text_color: color.textColor! });
                            setSection(SettingSections.main);
                            dispatch(setActiveElements(false));
                            dispatch(setSettingPopover(false));
                        }}
                    >
                        <span>{color.textName}</span>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default memo(SubtitlesTextColorsMenu);
